import React, { Component } from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import { Formik } from 'formik';
import _ from 'lodash';
import config from '../config';
import JsonEditorComponent from '../JsonEditorComponent'
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {downloadFile, readFileAsync} from "../components/ImportExport";
import {currencies} from "../components/Currencies";

export default class Events extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        // Define all possible columns with their display names
        const allColumns = [
            { key: '_id', label: 'Id' },
            { key: 'reviewUrl', label: 'Review Img' },
            { key: 'title', label: 'Title' },
            { key: 'v', label: 'Version' },
            { key: 'groupId', label: 'Group Id' },
            { key: 'displayGroupId', label: 'Display Group Id' },
            { key: 'startTime', label: 'Start Time' },
            { key: 'endTime', label: 'End Time' },
            { key: 'timeType', label: 'Time Type' },
            { key: 'isActive', label: 'Is Active' },
            { key: 'disable', label: 'Disabled' },
            { key: 'cohortIds', label: 'Cohort Ids' },
            { key: 'iconUrl', label: 'Icon Image' },
            { key: 'backUrl', label: 'Background Image' },
            { key: 'prefabTemplate', label: 'Prefab Template' },
            { key: 'repeatN', label: 'Repeat Count' },
            { key: 'maxSubOfferIndex', label: 'Max Sub-Offer Index' },
            { key: 'subOffers', label: 'Sub-Offers' }
        ];
        // Load visible columns from localStorage or default to a subset
        const savedColumns = JSON.parse(localStorage.getItem('offerLinesColumns')) || [
            'reviewUrl', 'name', 'v', 'startTime', 'endTime', 'subOffers'
        ];
        this.state = {
            objects: [],
            redirect: null,
            allColumns,
            visibleColumns: savedColumns
        };
        this.init = this.init.bind(this);
        this.remove = this.remove.bind(this);
        this.restart = this.restart.bind(this);
        this.disable = this.disable.bind(this);
        this.exportObjs = this.exportObjs.bind(this);
        this.importObjs = this.importObjs.bind(this);
        this.copy = this.copy.bind(this);
        this.toggleColumn = this.toggleColumn.bind(this);
        this.init();
    }

    async init()  {
        fetcher(`${config.API()}collection/offer-lines`)
            .then(response => response.json())
            .then(objects => {
                this.setState({objects});
            });
    }

    disable = (values) => {
        return () => {
            if(!values.hasOwnProperty("disable"))
                values.disable = false;

            values.disable = !values.disable
            let body = JSON.stringify(values);
            fetcher(`${config.API()}collection/offer-lines/save`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body
            })
                .then(response => response.json())
                .then(data => {
                    this.init();
                });
        }
    }

    remove = (objectId) => {
        return (e) => {
            let isOk = window.confirm("Are you sure?");
            if(!isOk)
                return;
            fetcher(`${config.API()}collection/offer-lines/remove/${objectId}`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body:"{}"
            })
                .then(response => response.json())
                .then(data => {
                    let objects = this.state.objects;
                    _.remove(objects, x => x._id == objectId)
                    this.setState({objects})
                });
        }
    }

    linkToEdit = (objectId) => {
        return () => {
            this.setState({redirect: `/offer-lines/${objectId}`});
        }
    }

    restart = (values) => {
        return (e) => {
            values.v += 1;
            let body = JSON.stringify({
                _id: values._id,
                sequenceId: values.v
            });

            fetcher(`${config.API()}collection/event-sequences/save`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body
            }) .then(response => response.json())
                .then(data => {
                    this.init();
                });
        }
    }

    copy = (values) => {
        return (e) => {
            if (values.timeType === 'daterange') {
                delete values.weekly;
            }

            if (values.timeType === 'weekly') {
                delete values.dateRanges;
            }
            values._id = "new";
            var body = JSON.stringify(values);

            let isOk = window.confirm("Are you sure?");
            if(!isOk)
                return;

            fetcher(`${config.API()}collection/offer-lines/save`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body
            })
                .then(response => response.json())
                .then(data => {
                    window.location.reload();
                });
        }
    }

    exportObjs = () => downloadFile(JSON.stringify(this.state.objects, null, "\t"), "offer-lines.json", 'text/plain')

    exportObj = (obj) => function (e){
        downloadFile(JSON.stringify([obj], null, "\t"), `offer-lines_${obj.title}.json`, 'text/plain')
    }

    importObjs = async (e) => {
        let text = await readFileAsync(e)
        let objs = JSON.parse(text)
        this.setState({objects: objs})
        await fetcher(`${config.API()}collection/offer-lines/import`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: text
        })
    }

    toggleColumn = (columnKey) => {
        return (e) => {
            const visibleColumns = this.state.visibleColumns.includes(columnKey)
                ? this.state.visibleColumns.filter(key => key !== columnKey)
                : [...this.state.visibleColumns, columnKey];
            this.setState({ visibleColumns });
            // Save to localStorage
            localStorage.setItem('offerLinesColumns', JSON.stringify(visibleColumns));
        }
    }

    renderCell = (obj, key) => {
        const value = obj[key];
        if (key === 'cohortIds' && Array.isArray(value)) {
            return value.join(', ');
        } else if (key === 'subOffers' && Array.isArray(value)) {
            if (value.length === 0) return 'None';
            return value.map((subOffer, index) => {
                const rewards = subOffer.rewards?.currencies?.map(c => `${c.value} ${this.getCurrencyName(c.key)}`).join(', ') || 'No rewards';
                return (
                    <div key={index} className="small">
                        {subOffer.productId} | {rewards}
                    </div>
                );
            });
        } else if (['iconUrl', 'backUrl', 'reviewUrl', 'titleUrl'].includes(key) && value) {
            return <img src={value} alt={key} style={{ width: '48px', height: '48px', objectFit: 'contain' }} />;
        } else if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        } else if (value === null || value === undefined) {
            return '';
        }
        return String(value);
    }

    getCurrencyName = (key) => {
        let c = _.find(currencies, x=>x.v == key);
        return c ? c.n : `Currency ${key}`;
    }

    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }

        return (
            <div>
                <div className="card shadow w100">
                    <div className="card-header py-3 d-flex justify-content-between align-items-center">
                        <h2 className="m-0 font-weight-bold"> Offer lines </h2>
                        <div>
                            <div className="dropdown d-inline-block mr-2">
                                <button className="btn btn-icon btn-light dropdown-toggle" type="button" id="columnDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="fas fa-fw fa-columns"></i> Columns
                                </button>
                                <div className="dropdown-menu" aria-labelledby="columnDropdown">
                                    {this.state.allColumns.map(col => (
                                        <div key={col.key} className="dropdown-item">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={this.state.visibleColumns.includes(col.key)}
                                                    onChange={this.toggleColumn(col.key)}
                                                    id={`col-${col.key}`}
                                                />
                                                <label className="form-check-label" htmlFor={`col-${col.key}`}>
                                                    {col.label}
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <input onChange={this.importObjs} type="file" id="file-input" className="btn btn-icon btn-light ml-1"/>
                            <button onClick={this.exportObjs} className="btn btn-icon btn-light ml-1">
                                <i className="fas fa-fw fa-arrow-circle-down"></i> Export
                            </button>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                                   cellSpacing="0">
                                <thead>
                                <tr>
                                    <th></th>
                                    {this.state.allColumns.map(col => (
                                        this.state.visibleColumns.includes(col.key) && (
                                            <th key={col.key}>{col.label}</th>
                                        )
                                    ))}
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.objects && this.state.objects.map((x,i) =>
                                    <tr className={(x.isActive && !x.disable ? "active" : "")} key={x._id} >
                                        <td><button className={`btn ${x.disable ? "btn-outline-danger" : "btn-outline-primary"} btn-circle btn-sm`} onClick={this.disable(x)} ><i className={`fa ${x.disable ? "fa-toggle-off" : "fa-toggle-on"}`}></i></button></td>
                                        {this.state.allColumns.map(col => (
                                            this.state.visibleColumns.includes(col.key) && (
                                                <td key={col.key}>{this.renderCell(x, col.key)}</td>
                                            )
                                        ))}
                                        <td>
                                            <button className="btn btn-outline-danger btn-circle btn-sm" onClick={this.remove(x._id)} ><i className="fa fa-remove"></i></button>
                                            <button className="btn btn-outline-warning btn-circle btn-sm" onClick={this.restart(x)} ><i className="fa fa-refresh"></i></button>
                                            <button className="btn btn-outline-primary btn-circle btn-sm" onClick={this.copy(x)} ><i className="fa fa-copy"></i></button>
                                            <button className="btn btn-outline-primary btn-circle btn-sm" onClick={this.exportObj(x)} ><i className="fa fa-save"></i></button>
                                            <button className="btn btn-outline-primary btn-circle btn-sm" onClick={this.linkToEdit(x._id)} ><i className="fa fa-edit"></i></button>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                        <div className="r">
                            <button onClick={this.linkToEdit("new")} className="btn btn-icon btn-primary ml-1"><i className="fas fa-fw fa-plus-square"></i> Add </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}